import { render, staticRenderFns } from "./CommunityList.vue?vue&type=template&id=3a6ea00f&scoped=true"
import script from "./CommunityList.vue?vue&type=script&lang=js"
export * from "./CommunityList.vue?vue&type=script&lang=js"
import style0 from "./CommunityList.vue?vue&type=style&index=0&id=3a6ea00f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6ea00f",
  null
  
)

export default component.exports